import { render, staticRenderFns } from "./SportsCover_c3.vue?vue&type=template&id=5b61f0c2&"
import script from "./SportsCover_c3.vue?vue&type=script&lang=js&"
export * from "./SportsCover_c3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports